// extracted by mini-css-extract-plugin
export default {"cls1":"zwyqNXPqLbg9eFQZTN0S","cls2":"baM5t3oXetmknMu9YL2P zwyqNXPqLbg9eFQZTN0S"};